import Vue from 'vue';
import VueI18n from 'vue-i18n';
// import en from '../assets/i18n/en.json';
// import de from '../assets/i18n/de.json';
// import fr from '../assets/i18n/fr.json';
// import es from '../assets/i18n/es.json';
// import it from '../assets/i18n/it.json';
// import pt from '../assets/i18n/pt.json';
// import nl from '../assets/i18n/nl.json';
// import tr from '../assets/i18n/tr.json';
import { I18CONFIG } from './config.js';
import { setupFormatters, formatter } from './formatter';

Vue.use(VueI18n);

let i18nMode = 'production';

export const toggleI18nMode = () => {
  if (i18nMode === 'dev') {
    setI18nProductionMode();
  } else {
    setI18nDevMode();
  }


  console.log({
    'i18nMode': i18nMode
  });
}

const setI18nDevMode = () => {
  i18nMode = 'dev';
  // Reload i18n messages
  seti18nLocaleMessage(i18n.locale, i18n.messages[i18n.locale]);
}
const setI18nProductionMode = () => {
  i18nMode = 'production';
  // Reload i18n messages
  seti18nLocaleMessage(i18n.locale, i18n.messages[i18n.locale]);
}

export const transformUndNull = (obj) => {
  Object.keys(obj).map(k => {
    if (obj[k] === null || obj[k] === undefined) {
      obj[k] = k + '●';
    }
  });
  return obj;
};


const messages = {
  // en,
  // de,
  // fr,
  // es,
  // it,
  // pt,
  // nl,
  // tr
};

// var loadedLanguages = ['en', 'de', 'fr', 'es', 'it', 'pt', 'nl', 'tr'];
// var loadedLanguages = ['en', 'de'];
var loadedLanguages = [];


export const getLoadedLanguages = () => {
  return {
    ...loadedLanguages
  };
};

export const isInLoadedLang = (lang) => {
  return loadedLanguages.includes(lang);
};

export const geti18n = (VueI18n) => new VueI18n({
  locale: 'de', // set locale
  fallbackLocale: 'de',
  messages
});

const setupInternatinoalization = (locale = I18CONFIG.LOCALE, currency = I18CONFIG.CURRENCY) => {
  // setupFormatters(locale, currency);
  formatter.setup(locale, currency);
}
setupInternatinoalization();


export const i18n = new VueI18n({
  locale: '', // set locale
  fallbackLocale: 'de',
  messages,
  silentTranslationWarn: true,

  missing: (locale, key, vm) => {
    // If Keys are missing, show the key preceeded by a error unicode character
    if (i18nMode === 'dev') {
      return `⚠️${key}`;
    }

    if (locale === 'keys') {
      return `⚠️🔑${key}`;
    }
    return key;
  },
});

// console.log(i18n);

export function setI18nLanguage(lang) {
  i18n.locale = lang;
  // console.log(i18n);
  setupInternatinoalization(lang);
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

export function loadLanguage(lang, langObject) {
  if (Object.keys(langObject).length > 0) {
    seti18nLocaleMessage(lang, langObject);
    setI18nLanguage(lang);
  } else {
    setI18nLanguage(lang);
  }
  // if (i18n.locale !== lang) {
  //   if (loadedLanguages.includes(lang)) {
  //     setI18nLanguage(lang);
  //   } else {
  //     seti18nLocaleMessage(lang, langObject);
  //     loadedLanguages.push(lang);
  //     setI18nLanguage(lang);
  //   }
  // }
}
export function insertSectionToLanguage(lang, langObject) {
  // console.log(i18n.messages[lang]);
  seti18nLocaleMessage(lang, langObject);
}

export const seti18nLocaleMessage = (lang, langObject) => {
  i18n.setLocaleMessage(lang, {
    ...(i18n.messages[lang] || {}),
    ...(langObject || {})
  });
}



// take first data of i18n.messages
// and make a object with key: key
const getKeyKeyObject = () => {
  const keyKeyObject = {};
  const keys = i18n.messages[Object.keys(i18n.messages)[0]];
  for (let key in keys) {
    keyKeyObject[key] = `🔑${key}`;
  }
  return keyKeyObject;
}